import React, { useEffect, useState } from 'react'
import Billing from './Billing'
import ServiceTax from './ServiceTax'
import { TaxAndBillingDetailsType } from '../../../../commonTypes/clientDirectoryTypes';
type AppProps = {
    clientAadharUniqueCheckMessage: string | null;
    clientPanUniqueCheckMessage: string | null;
    taxAndBillingDetails: TaxAndBillingDetailsType;
    handleClientDirectoryFormSubmit: () => void;
    handleGoBack: () => void;
    singleClientDirectory: any;
    setTaxAndBillingDetails: (data: TaxAndBillingDetailsType) => void;
    isDisabled?: boolean;
    isViewClientPresent?:boolean
}
const TaxAndBillingTab = ({
    clientAadharUniqueCheckMessage,
    clientPanUniqueCheckMessage,
    taxAndBillingDetails,
    handleClientDirectoryFormSubmit,
    handleGoBack,
    singleClientDirectory,
    setTaxAndBillingDetails,
    isDisabled,
    isViewClientPresent
}: AppProps) => {
    return (
        <div className='card'>
            <h5>Tax and Billing</h5>
            <span className='mb-3'>Update your Tax and Billing details here</span>
            <p style={{ marginTop: "3px", fontWeight: "500" }}>SERVICE TAX</p>
            <ServiceTax
                serviceTaxDetails={taxAndBillingDetails?.serviceDetails}
                setTaxAndBillingDetails={setTaxAndBillingDetails}
                isDisabled={isDisabled}
            />
            <p style={{ marginTop: "20px", fontWeight: "500" }}>BILLING</p>
            <Billing
                billingDetails={taxAndBillingDetails?.billingDetails}
                setTaxAndBillingDetails={setTaxAndBillingDetails}
                isDisabled={isDisabled}
            />
            <hr></hr>
            <div className='row'>
                <div className='col-md-12 text-right'>
                    <button  className={isViewClientPresent?"btn-primary btn":"btn" } style={{ border: "1px solid #bfcbe1", marginRight: '15px' }}
                        onClick={() => handleGoBack()}
                    > {isViewClientPresent ? "Back" : "Cancel"}</button>
                   {!isViewClientPresent? <button className='btn btn-primary'
                        disabled={clientPanUniqueCheckMessage?.includes("PAN number already exists") || clientAadharUniqueCheckMessage?.includes("Aadhaar number already exists")}
                        onClick={handleClientDirectoryFormSubmit}
                    >{singleClientDirectory ? "Save Changes" : "Save"}</button>:""}
                </div>
            </div>
        </div>)
}

export default TaxAndBillingTab